export default __webpack_public_path__ + "img/arc.bb461607.svg";